import LocomotiveScroll from 'locomotive-scroll';
const $ = jQuery;

export default class Scroll {
	static init(){
		const scrollContainer = document.querySelector('[data-scroll-container]');
		new Scroll(scrollContainer);
	}

	constructor(scrollContainer){

		this.scrollContainer = scrollContainer;

        this.scroll = new LocomotiveScroll({
            el: this.scrollContainer,
            smooth: true,
			getDirection: true,
        });

		$(document).on('gform_confirmation_loaded', () => {
			this.scroll.update();
        });
	}
}
